import { apiGetStudent } from '../../common/api/student-management'

const fetchPupil = id => ({
  requestPrefix: 'PUPIL_STORE:FETCHING',
  params: { id },
  request: () =>
    apiGetStudent(id, {
      include: 'account.names,account.student_type.policy'
    })
})

export { fetchPupil }
